import React from "react";
import { map } from "lodash";
import styled from "styled-components";
import { Locale } from "@linkfluence/models/locale";
import ClauseLabelsDisplay from "@radarly/components/clause/labels/labels";
import { ClauseLabels } from "@radarly/models/clause/label";

interface VerticalRecapProps {
  clausesLabels: ClauseLabels[];
  locale: Locale;
  colorized?: boolean;
  maxItemPerLine?: number;
  className?: string;
}

const FilterLine = styled.div`
  overflow-wrap: normal;
  display: flex;
  flex-wrap: wrap;
  &:not(:first-child) {
    margin-top: 12px;
  }
`;

export default function VerticalRecap({
  clausesLabels,
  locale,
  colorized,
  maxItemPerLine = 25,
  className,
}: VerticalRecapProps) {
  return (
    <div className={className}>
      {map(clausesLabels, (clauseLabels, i) => (
        <FilterLine key={i}>
          <ClauseLabelsDisplay
            colorized={colorized}
            clauseLabels={clauseLabels}
            locale={locale}
            max={maxItemPerLine}
          />
        </FilterLine>
      ))}
    </div>
  );
}
